module.exports = __webpack_public_path__ + "static/media/DSC_0842.27d221cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0842.jpg
// module id = 603
// module chunks = 0